import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { PageHelpMap } from './page-help-modals.typing';

@RegisterYCState()
export class PageHelpModalState extends BaseYcState {
  readonly pageHelpDismissedMap: PageHelpMap;
}
